import { useEffect } from 'react';
import { useAppDispatch, useAppSelector } from '../../../store/hooks';
import { getBrandList } from '../../../store/INV/Brands/BrandSlice';
import { useTranslation } from 'react-i18next';

const useGetBrandList = () => {
  const dispatch = useAppDispatch();

  const { i18n } = useTranslation();
  useEffect(() => {
    if (BrandList?.length === 0) {
      dispatch(getBrandList());
    }
  }, []);
  const { BrandList, loading, error } = useAppSelector((state) => state.Brand);

  const BrandListOptions = BrandList?.map((item) => ({
    value: item.id,
    label: `${i18n.language === 'en' ? item.name : item.name2}`,
  }));

  return { BrandList, BrandListOptions, loading, error };
};

export default useGetBrandList;
